/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentTypeStatus } from './ComponentTypeStatus';
import {
    ComponentTypeStatusFromJSON,
    ComponentTypeStatusFromJSONTyped,
    ComponentTypeStatusToJSON,
    ComponentTypeStatusToJSONTyped,
} from './ComponentTypeStatus';

/**
 * 
 * @export
 * @interface CreateComponentTypeRequestDto
 */
export interface CreateComponentTypeRequestDto {
    /**
     * Name of the ComponentType
     * @type {string}
     * @memberof CreateComponentTypeRequestDto
     */
    name: string;
    /**
     * Status of the ComponentType
     * @type {ComponentTypeStatus}
     * @memberof CreateComponentTypeRequestDto
     */
    status?: ComponentTypeStatus;
    /**
     * List of synonyms for this ComponentType
     * @type {Array<string>}
     * @memberof CreateComponentTypeRequestDto
     */
    synonyms?: Array<string>;
}



/**
 * Check if a given object implements the CreateComponentTypeRequestDto interface.
 */
export function instanceOfCreateComponentTypeRequestDto(value: object): value is CreateComponentTypeRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateComponentTypeRequestDtoFromJSON(json: any): CreateComponentTypeRequestDto {
    return CreateComponentTypeRequestDtoFromJSONTyped(json, false);
}

export function CreateComponentTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateComponentTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'status': json['status'] == null ? undefined : ComponentTypeStatusFromJSON(json['status']),
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
    };
}

export function CreateComponentTypeRequestDtoToJSON(json: any): CreateComponentTypeRequestDto {
    return CreateComponentTypeRequestDtoToJSONTyped(json, false);
}

export function CreateComponentTypeRequestDtoToJSONTyped(value?: CreateComponentTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': ComponentTypeStatusToJSON(value['status']),
        'synonyms': value['synonyms'],
    };
}

